import mutations from './drugSelect.mutations'
import actions from './drugSelect.actions'
import getters from './drugSelect.getters'

import initialState from './defaultState'

const state = initialState()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
